module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 widget"
  }, [_c('description')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 widget"
  }, [_c('news')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 widget"
  }, [_c('links')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 widget"
  }, [_c('contact')], 1)])])]), _vm._v(" "), _c('subfooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be02795e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Footer.vue
// module id = 391
// module chunks = 0